import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/tool/importer/toolImporterActions';

export default importerReducers(actions);
